
/*
=============================================================================
auto-generated ***
to refresh you will need to run
npm run build:model
This code was generated by a tool.
¯\_(ツ)_/¯

Changes to this file may cause incorrect behavior and will be lost if
the code is regenerated.
=============================================================================
*/

export const $scat_$ancillary_id: string = "9c309c21-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$ancillary_name: string = "Ancillary";
export const $scat_$cobra_id: string = "67c13d28-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$cobra_name: string = "COBRA";
export const $scat_$dental_id: string = "984f4b41-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$dental_name: string = "Dental";
export const $scat_$fsa_id: string = "7ec13d28-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$fsa_name: string = "FSA";
export const $scat_$hra_id: string = "1c17e42e-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$hra_name: string = "HRA";
export const $scat_$hsa_id: string = "2117e42e-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$hsa_name: string = "HSA";
export const $scat_$lsa_id: string = "ac4f4b41-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$lsa_name: string = "LSA";
export const $scat_$medical_id: string = "f34be834-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$medical_name: string = "Medical";
export const $scat_$pharmacy_id: string = "fa4be834-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$pharmacy_name: string = "Pharmacy";
export const $scat_$telehealth_id: string = "95309c21-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$telehealth_name: string = "Telehealth";
export const $scat_$vision_id: string = "18f6013b-a06c-ef11-bfe2-7c1e5215b594";
export const $scat_$vision_name: string = "Vision";
